<div class="ds-card">
  <div class="ds-card__cabecera">
    <span
      class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTACTOSANOTIFICAR' | translate }}</span>
  </div>
  <div class="grid align-items-end">
    <div class="col-2">
      <app-boton-icono icono="assets/icons/icono-mas.svg" (click)="abrirSidebarAgregar()">
        {{ 'BTN_AGREGAR' | translate }}
      </app-boton-icono>
    </div>
    <div class="col-10 ds-buscador">
      <span class="p-input-icon-left">
        <img src="assets/icons/ico-buscar-lupa.svg" alt="">
        <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroContactos">
      </span>
    </div>
  </div>
  <p-table [value]="contactosFiltrados" [loading]="cargandoContactos" [paginator]="true" [rows]="5"
           [alwaysShowPaginator]="true" styleClass="ds-tabla">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'LBL_NOMBRE' | translate }}</th>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMEROTELEFONO' | translate }}</th>
        <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CORREO' | translate }}</th>
        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-ct>
      <tr>
        <td>{{ ct.nombreContacto || '--' }}</td>
        <td>{{ (ct.numeroTelefono | telefono) || '--' }}</td>
        <td>{{ ct.correoElectronico || '--' }}</td>
        <td class="text-center">
          <!-- ponytail: edición/eliminación de contacto existente quedan para un paso posterior -->
          <button type="button" class="btn-action-premium ds-btn-icono-editar"
                  title="{{ 'BTN_EDITAR' | translate }}">
            <span class="ds-icono-editar"></span>
          </button>
          <button type="button" pButton class="btn-action-premium" icon="fa fa-trash-o"
                  title="{{ 'BTN_ELIMINAR' | translate }}"
                  (click)="eliminarContacto(ct)">
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-sidebar [(visible)]="sidebarVisible" position="right" styleClass="w-30rem admsb-sidebar-editar"
           transitionOptions="400ms cubic-bezier(0, 0, 0.2, 1)" [blockScroll]="true">
  <ng-template pTemplate="header">
    <span
      class="admsb-sidebar-editar__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_AGREGARCONTACTO' | translate }}</span>
  </ng-template>

  <form [formGroup]="formulario" class="admsb-sidebar-editar__cuerpo">
    <div class="div-form">
      <label>*{{ 'LBL_NOMBRE' | translate }}</label>
      <input type="text" pInputText formControlName="nombreContacto" sin-numeros-reactive
             maxlength="150" (blur)="capitalizarNombre()">
      <div class="p-message p-messages-error p-corner-all"
           *ngIf="submitted && formulario.get('nombreContacto').invalid">
        {{ 'LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
      </div>
    </div>

    <div class="admsb-contacto-canales">
      <div class="div-form flex align-items-center gap-2">
        <p-checkbox binary="true" formControlName="incluirTelefono" (onChange)="onToggleTelefono()"></p-checkbox>
        <label class="mb-0">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMEROTELEFONO' | translate }}</label>
      </div>
      <div class="div-form flex align-items-center gap-2">
        <p-checkbox binary="true" formControlName="incluirCorreo" (onChange)="onToggleCorreo()"></p-checkbox>
        <label class="mb-0">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CORREO' | translate }}</label>
      </div>
    </div>
    <div class="p-message p-messages-error p-corner-all"
         *ngIf="submitted && !formulario.value.incluirTelefono && !formulario.value.incluirCorreo">
      {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_SELECCIONEUNMEDIO' | translate }}
    </div>

    <!-- Bloque teléfono -->
    <ng-container *ngIf="formulario.value.incluirTelefono">
      <div class="div-form">
        <label>*{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMEROTELEFONO' | translate }}</label>
        <div class="admsb-contacto-campo-codigo">
          <input type="text" pInputText formControlName="numeroTelefono" numero-telefono-reactive
                 [telFijo]="false" maxlength="14" [readonly]="telefonoVerificado"
                 (change)="onCambioTelefono()">
          <button type="button" pButton class="btn-primary-outline"
                  label="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_SOLICITARCODIGO' | translate }}"
                  [disabled]="solicitandoCodigoTelefono || telefonoVerificado || !!hashOtpTelefono"
                  (click)="solicitarCodigoTelefono()"></button>
        </div>
        <div class="p-message p-messages-error p-corner-all"
             *ngIf="(submitted || formulario.get('numeroTelefono').touched) && formulario.get('numeroTelefono').invalid">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NUMEROTELEFONO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
        </div>
      </div>

      <div class="admsb-contacto-verificacion">
        <span
          class="admsb-contacto-verificacion__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VERIFICACION' | translate }}</span>
        <span class="admsb-chip-estado admsb-chip-estado--activo" *ngIf="telefonoVerificado">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VERIFICADO' | translate }}
        </span>
        <p class="admsb-contacto-verificacion__ayuda" *ngIf="!telefonoVerificado && !hashOtpTelefono">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_SOLICITECODIGO' | translate }}
        </p>
        <app-formulario-codigo-otp *ngIf="!telefonoVerificado && hashOtpTelefono" [showTimer]="true"
                                   (codeRequested)="solicitarCodigoTelefono()"
                                   (formValueSubmitted)="confirmarCodigoTelefono($event)"></app-formulario-codigo-otp>
      </div>
    </ng-container>

    <!-- Bloque correo -->
    <ng-container *ngIf="formulario.value.incluirCorreo">
      <div class="div-form">
        <label>*{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CORREO' | translate }}</label>
        <div class="admsb-contacto-campo-codigo">
          <input type="text" pInputText formControlName="correoElectronico"
                 [readonly]="correoVerificado" (change)="onCambioCorreo()">
          <button type="button" pButton class="btn-primary-outline"
                  label="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_SOLICITARCODIGO' | translate }}"
                  [disabled]="solicitandoCodigoCorreo || correoVerificado || !!hashOtpCorreo"
                  (click)="solicitarCodigoCorreo()"></button>
        </div>
        <div class="p-message p-messages-error p-corner-all"
             *ngIf="(submitted || formulario.get('correoElectronico').touched) && formulario.get('correoElectronico').invalid">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CORREO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
        </div>
      </div>

      <div class="admsb-contacto-verificacion">
        <span
          class="admsb-contacto-verificacion__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VERIFICACION' | translate }}</span>
        <span class="admsb-chip-estado admsb-chip-estado--activo" *ngIf="correoVerificado">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VERIFICADO' | translate }}
        </span>
        <p class="admsb-contacto-verificacion__ayuda" *ngIf="!correoVerificado && !hashOtpCorreo">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_SOLICITECODIGO' | translate }}
        </p>
        <app-formulario-codigo-otp *ngIf="!correoVerificado && hashOtpCorreo" [showTimer]="true"
                                   (codeRequested)="solicitarCodigoCorreo()"
                                   (formValueSubmitted)="confirmarCodigoCorreo($event)"></app-formulario-codigo-otp>
      </div>
    </ng-container>
  </form>

  <ng-template pTemplate="footer">
    <div class="admsb-sidebar-editar__footer">
      <button type="button" pButton class="btn-primary-outline"
              label="{{ 'BTN_CANCELAR' | translate }}"
              (click)="cerrarSidebar()"></button>
      <button type="button" pButton class="btn-primary-full"
              icon="{{ guardandoContacto ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-floppy-o' }}"
              label="{{ 'BTN_GUARDAR' | translate }}"
              [disabled]="!puedeGuardar || guardandoContacto"
              (click)="guardarContacto()"></button>
    </div>
  </ng-template>
</p-sidebar>

<p-confirmDialog #cdContactos key="admsb-contactos-modal" styleClass="ds-confirm">
  <ng-template pTemplate="footer">
    <app-boton-icono iconoFa="fa fa-close" variante="outline"
                     (click)="cdContactos.reject()">{{ 'LBL_NO' | translate }}
    </app-boton-icono>
    <app-boton-icono iconoFa="fa fa-check" variante="full"
                     (click)="cdContactos.accept()">{{ 'LBL_SI' | translate }}
    </app-boton-icono>
  </ng-template>
</p-confirmDialog>
